import type { SlideProps } from "@/engine/app/offsite-config";

/**
 * Titelfolie der AR-Session. Steht die ersten Minuten, während sich das
 * Gremium setzt. Ein Fokuspunkt, sonst Fläche.
 */
export function Slide01Titel(_: SlideProps) {
  return (
    <div
      className="deck-root ar-slide ar-slide--hero"
      style={{ background: "var(--ink-900)" }}
    >
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1" style={{ color: "var(--ink-400)" }}>
          SVO · Aufsichtsrat
        </div>
        <h1 className="deck-title t-display rise rise-2">KI-Session</h1>
        <hr className="ar-rule rise rise-3" />
        <p className="deck-sub rise rise-4">
          25 Minuten. Sie beschreiben auf Ihrem Handy, was Ihnen im Alltag
          Arbeit macht. Am Ende läuft daraus eine erste Anwendung auf dieser
          Leinwand.
        </p>
      </header>

      {/* Kein Fuß auf dieser Folie: Name, Position und Gesellschaft gehören
          nicht auf die Leinwand — wer spricht, steht daneben. Die Zuordnung
          zum Haus macht die Zeile „SVO · Aufsichtsrat" über der Überschrift. */}
    </div>
  );
}
